<template>
  <v-container fluid class="mx-1">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="e1" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header class="autoheight" v-if="languageData.labels">
              <div class="py-5 pl-5">
                <BackButton />
              </div>
              <v-stepper-step :complete="e1 > 1" @click="setStep(1)" step="1">{{ languageData.labels.selectClientLabel }}</v-stepper-step>
              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" @click="setStep(2)" step="2">{{ languageData.labels.addEstimation }}</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>
          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card elevation="0">
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formStep1">
                        <ClientsTableForm noClientType :layout="layout" :clients="data.clients" :clientsTypes="selectedId"></ClientsTableForm>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="e1 = 2">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card elevation="0">
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formStep2">
                        <p class="text-h5 mb-7" style="display: flex; align-items: center">
                          {{ languageData.estimation }}
                          <span v-on:click.stop @click="openGuidesModal" class="guides-question-mark">?</span>
                        </p>
                        <v-btn @click="showEstimationModal" color="primary">{{ layout === 'edit' ? languageData.editEstimation : languageData.addEstimation }}</v-btn>
                        <EstimatePreview v-if="estimateData" :estimateData="estimateData" :isOfferForm="true"></EstimatePreview>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="e1 = 1">
                    {{ languageData.back }}
                  </v-btn>
                </div>
              </v-stepper-content>
              <div class="d-flex justify-end flex-wrap" style="padding: 0 24px">
                <v-btn
                    v-if="layout === 'add'"
                    class="button-shadow btnSaveOffer mb-5"
                    color="primary"
                    outlined
                    height="55px"
                    @click="saveOfferAndSend">{{ languageData.btnSaveAndSendText }}</v-btn>
                <v-btn
                    class="button-shadow btnSaveOffer mb-5 ml-3"
                    color="primary"
                    height="55px"
                    :loading="dataSaveIsFetching || isFetchingUpdate"
                    @click="saveOffer">{{ languageData.btnSaveText }}</v-btn>
              </div>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <ModalInfo :typeInfo="typeInfoOfferSave || typeInfoOfferUpdate" :headModal="headInfoOfferSave || headInfoOfferUpdate" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isOfferSave || isOfferUpdate" :text-modal="textInfoOfferSave || textInfoOfferUpdate"></ModalInfo>
    <ModalInfo :layout="'modalClientForm'" :hidden-agree-btn="true" @clicked="hideModalAddClientForm" :show-modal="isAddClientForm">
      <template v-slot:body>
        <ClientsForm :layout="'offerForm'"></ClientsForm>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideModalAddClient" :show-modal="isAddClient">
      <template v-slot:body>
        <ClientsTableSelect isOfferForm :deletedId="deletedId" :selectedId="selectedId" :layout="'offerSelectClient'"></ClientsTableSelect>
      </template>
    </ModalInfo>
    <ModalInfo :scrollable="true" :layout="'modalEstimate'" :hidden-agree-btn="true" @clicked="hideModalEstimation" :show-modal="isShowEstimationModal" >
      <template v-slot:body>
        <Estimate isOfferForm :data="estimateData"></Estimate>
      </template>
      <template v-slot:actions v-if="languageData.labels">
        <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-wrap justify-center' : null">
        <v-btn
            color="primary"
            outlined
            class="mr-4"
            :class="$vuetify.breakpoint.xsOnly ? 'mb-4' : null"
            @click="addCategoryEvent">
          {{ languageData.labels.add_category }}
        </v-btn>
        <v-btn
            color="primary"
            :loading="isSaving"
            @click="saveEstimateEvent">
          {{ languageData.labels.save_estimation }}
        </v-btn>
        </div>
      </template>
    </ModalInfo>
    <ModalInfo :layout="'modalProjectForm'" persistent :hidden-agree-btn="true" @clicked="hideModalShowProjectForm" :show-modal="showProjectFormModal">
      <template v-slot:body>
        <ProjectsForm v-if="showProjectFormModal" isOffer :layout="'add'" :offerData="offerData"></ProjectsForm>
      </template>
    </ModalInfo>
    <ModalInfo
        :typeInfo="typeInfoOfferAccept"
        :headModal="headInfoOfferAccept"
        :btnAgreeText="languageData.btnAgreeText"
        @clicked="hideModalAcceptInfo"
        :show-modal="isOfferAccept"
        :text-modal="textInfoOfferAccept"></ModalInfo>
    <ModalInfo
        @doOperation="acceptCloseProjectFormModal"
        :isLoadingBtn="false"
        :typeInfo="'red'"
        :headModal="languageData.headInfoModalClosing"
        :btnDisAgreeText="languageData.btnStay"
        :btnAgreeText="languageData.btnCloseModal"
        :visDisAgreeBtn="true"
        @clicked="hideCloseProjectFormModal"
        :show-modal="showCloseProjectFormModal"
        :text-modal="languageData.textInfoModalClosing"></ModalInfo>
  </v-container>
</template>

<script>
import ClientsTableForm from "../../../Projects/components/ClientsTableForm/ClientsTableForm";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import ClientsTableSelect from "../../../Projects/components/ClientsTableSelect/ClientsTableSelect";
import ClientsForm from "../../../Clients/components/ClientsForm/ClientsForm";
import Estimate from "../../../Estimate/components/Estimate/Estimate";
import EstimatePreview from "../../../Estimate/components/EstimatePreview/EstimatePreview";
import {mapState, mapActions} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";
import router from "../../../../../router";
import offerStatusHelper from "../../../../helpers/offerStatusHelper";
import ProjectsForm from "../../../Projects/components/ProjectsForm/ProjectsForm";
import BackButton from "../../../../components/Global/BackButton";


export default {
  name: "OffersForm",
  props: {
    layout: String,
  },
  components: {
    BackButton,
    EstimatePreview, ModalInfo, ClientsTableForm, ClientsTableSelect, ClientsForm, Estimate, ProjectsForm },
  data() {
    return {
      e1: 1,
      selectedId: [],
      deletedId: [],
      selected: [],
      data: {
        clients: [],
        estimateData: {},
      },
      isAddClient: false,
      isAddClientForm: false,
      modalSaveInfoData: {},
      estimateData: null,
      getAcceptedValue: offerStatusHelper.getAcceptedValue,
      getDeclinedValue: offerStatusHelper.getDeclinedValue,
      getPendingValue: offerStatusHelper.getPendingValue,
      offerStatus: null,
      acceptedOfferData: {},
      showProjectFormModal: false,
      showCloseProjectFormModal: false,
      rules: {},
    }
  },
  computed: {
    ...mapState('getClients', {
      headers: state => state.headers
    }),
    ...mapState("showEstimationModal", {
      isShowEstimationModal: state => state.isShowEstimationModal
    }),
    ...mapState("saveEstimate", {
      isSaving: state => state.isSaving,
    }),
    ...mapState("getEstimate", {
      estimationsData: state => state.estimationsData
    }),
    ...mapState("getOffer", {
      dataReceive: state => state.dataReceive
    }),
    ...mapState("saveOffer", {
      dataSaveIsFetching: state => state.dataSaveIsFetching,
      typeInfoOfferSave: state => state.typeInfoOfferSave,
      headInfoOfferSave: state => state.headInfoOfferSave,
      isOfferSave: state => state.isOfferSave,
      textInfoOfferSave: state => state.textInfoOfferSave
    }),
    ...mapState("updateOffer", {
      isFetchingUpdate: state => state.isFetchingUpdate,
      typeInfoOfferUpdate: state => state.typeInfoOfferUpdate,
      headInfoOfferUpdate: state => state.headInfoOfferUpdate,
      isOfferUpdate: state => state.isOfferUpdate,
      textInfoOfferUpdate: state => state.textInfoOfferUpdate
    }),
    ...mapState("acceptOffer", {
      dataAcceptIsFetching: state => state.dataAcceptIsFetching,
      typeInfoOfferAccept: state => state.typeInfoOfferAccept,
      headInfoOfferAccept: state => state.headInfoOfferAccept,
      isOfferAccept: state => state.isOfferAccept,
      textInfoOfferAccept: state => state.textInfoOfferAccept,
      preparedOfferData: state => state.preparedOfferData,
    }),
  },
  methods: {
    ...mapActions('getClients', [ 'getHeadersTable']),
    ...mapActions('saveOffer', ['storeOffer', 'updateVisibleModalSave']),
    ...mapActions("updateOffer", ["updateOffer", "updateVisibleModalUpdate"]),
    ...mapActions("showEstimationModal", ["updateVisibleEstimationModal"]),
    ...mapActions("getOffer", ["getOffer"]),
    ...mapActions("acceptOffer", ["acceptOfferProjectData", "updateVisibleModal", "prepareOfferData"]),
    ...mapActions("getVat", ["getVat"]),
    ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),
    ...mapActions("updateVisibleGuideModal", ["updateGuidesModalVisible"]),

     getSnackbarSuccess: function(title, message) {
        this.snackbar = {
          color: "success",
          icon: "check_circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },

    hideModalEstimation: function() {
      this.updateVisibleEstimationModal(false);
    },
    hideModalAddClientForm: function() {
      this.isAddClientForm = false;
    },
    hideModalAddClient: function() {
      this.isAddClient = false;
    },
    showAddClientForm: function() {
      this.isAddClientForm = true;
    },
    hideModalShowProjectForm() {
      this.showCloseProjectModalWarning();
    },
    hideModalAcceptInfo() {
      this.updateVisibleModal(false);
    },
    hideCloseProjectFormModal() {
      this.showCloseProjectFormModal = false;
    },
    showCloseProjectModalWarning() {
      this.showCloseProjectFormModal = true;
    },
    acceptCloseProjectFormModal() {
      this.showProjectFormModal = false;
    },
    setStep: function(step) {
      this.e1 = step;
    },
    saveOfferAndSend() {
      const data = this.data;
      data.offerWillBeSend = true;
      this.storeOffer({creds: data});
      this.updateDataInFormIsChanged(false);
    },
    saveOffer() {
      this.updateDataInFormIsChanged(false);
      if(this.layout === "edit") {
        this.data.clientId = this.data.clients[0] !== undefined ? this.data.clients[0].id : null;
        this.data.offerStatus = this.dataReceive.status;
        this.updateOffer({creds: this.data});
      } else {
        this.storeOffer({creds: this.data});
      }
    },
    showEstimationModal: function() {
      this.updateVisibleEstimationModal(true);
    },
    hideModal: function() {
      if(this.layout === "edit") {
        this.updateVisibleModalUpdate(false);
      } else {
        this.updateVisibleModalSave(false);
      }
    },
    addCategoryEvent() {
      eventBus.$emit('addCategory');
    },
    saveEstimateEvent() {
      eventBus.$emit('saveOfferEstimate');
    },
    openGuidesModal() {
        this.updateGuidesModalVisible({
          isGuidesModalVisible: true,
          guideKey: 'makeOffer'
        });
      },
  },
  mounted() {
    this.getVat();
    this.updateLanguage(this.getCurrentLanguage);
    const language = this.getCurrentLanguage;
    this.getHeadersTable({creds: {language}});
    if(this.layout === 'edit') {
      this.getOffer();
    }
    eventBus.$on("changeLanguage", (value) => {
      const language = value;
      this.getHeadersTable({creds: {language}});
    });

    eventBus.$on("showChooseClientModal", () => {
      this.isAddClient = true;
      eventBus.$emit("filterSelectClients");
    });

    eventBus.$on("showOfferForm", () => {
      this.isAddClientForm = true;
    })

    eventBus.$on("deleteClientStep", (index, id) => {
      this.deletedId.push(id);
      this.selectedId.splice(this.selectedId.indexOf(id), 1);
      this.data.clientId = null;
    });

    eventBus.$on("showOfferForm", () => {
      this.isAddClientForm = true;
    });

    eventBus.$on("addOfferClientSelect", (item) => {
      this.selectedId.push({
        id: item.id,
        clientType: ""
      });
      this.data.clientId = item.id;
    });

    eventBus.$on("setOfferFormData", (data) => {
      this.data.estimateData = data.estimateData;
      this.data.estimation = data.estimation;
      this.data.clients.push(data.client);
      this.estimateData = data.estimateData;
      this.selectedId.push(data.client.id);
      if(data.status === this.getAcceptedValue()) {
        router.push({path: '/offers'}).catch(() => {})
      }
    });

    eventBus.$on("offerEstimatePrepare", (data) => {
      this.hideModalEstimation(true);
      this.data.estimateData = data.estimate;
      this.estimateData = data.estimate;
      this.data.parentsDeleted =  data.parentsDeleted;
      this.data.categoriesDeleted =  data.categoriesDeleted;
      this.data.itemsDeleted =  data.itemsDeleted;
      this.updateDataInFormIsChanged(true);

      this.snackbar = {
        color: "success",
        icon: "check_circle",
        position: "top",
        corner: 'right',
        title: 'Estimation added',
        visible: true
      };
    });

    eventBus.$on("storeClientSuccess", (clientId) => {
      this.isAddClientForm = false;
      this.isAddClient = false;
      this.modalSaveInfoData.typeInfo = "success";
      this.modalSaveInfoData.textInfo = localStorage.getItem("textSave");
      this.modalSaveInfoData.head = localStorage.getItem("messageSave");
      this.isShowSaveModalInfo = true;
      this.data.clientId = clientId;
      localStorage.removeItem("textSave");
      localStorage.removeItem("messageSave");
      eventBus.$emit('disableAddClientButton', true);
    });
    eventBus.$on("acceptOfferFromEdit", () => {
      this.showProjectFormModal = true;
      this.dataReceive.client.disableSelect = true;
      this.prepareOfferData(this.dataReceive);
      this.offerData = {
        clientsId: [this.preparedOfferData.client.id],
        clients: [this.preparedOfferData.client],
        clientsTypes: [
          {
            id: this.preparedOfferData.client.id,
            clientType: parseInt(Object.keys(this.languageData.clientTypes).find(key => this.languageData.clientTypes[key] === "RECIPIENT")),
          }
        ]
      };
    })
    eventBus.$on("acceptProjectOffer", (data) => {
      let projectData = data;
      let offerData = this.preparedOfferData;
      let creds = {
        projectData: projectData,
        offerData: offerData,
      };
      this.acceptOfferProjectData({creds: creds})
    });

    eventBus.$on("acceptOfferSuccess", () => {
      router.push({path: '/offers'}).catch(() => {})
    });
    eventBus.$on("declineOfferSuccess", () => {
      router.push({path: '/offers'}).catch(() => {})
    });
    eventBus.$on("pendingOfferSuccess", () => {
      router.push({path: '/offers'}).catch(() => {})
    });

    eventBus.$on("updateClientSuccessForSnackbar", (data) => {
      this.getSnackbarSuccess(data.message, data.data.textInfo);
    });
  },
  beforeDestroy(){
    eventBus.$off('acceptProjectOffer')
    eventBus.$off('declineOfferSuccess')
    eventBus.$off('pendingOfferSuccess')
    eventBus.$off('storeClientSuccess')
  }
}
</script>
